import { useState } from "react";

const reviews = [
  {
    initials: "KT",
    name: "Khai-Thanh Lan",
    service: "Reinigungsservice",
    date: "Juni 2025",
    rating: 5,
    text: "Sehr gewissenhafte Reinigung. Top Service. Kann Ihn und sein Team nur weiterempfehlen!",
  },
  {
    initials: "KH",
    name: "Klaus H.",
    service: "Gebäudereinigung",
    date: "November 2024",
    rating: 5,
    text: "Sehr professionelles Team! Die Büroreinigung wird seit Monaten pünktlich und gründlich durchgeführt. Man merkt, dass hier mit Herzblut gearbeitet wird. Absolute Weiterempfehlung!",
  },
  {
    initials: "SR",
    name: "Sabine R.",
    service: "Hausmeisterservice",
    date: "Oktober 2024",
    rating: 5,
    text: "Schnelle Reaktionszeit und faire Preise. Unser Hausmeisterproblem wurde innerhalb eines Tages gelöst. Sehr freundlicher Kontakt und saubere Arbeit – wir sind rundum zufrieden.",
  },
  {
    initials: "MF",
    name: "Marco F.",
    service: "Schlüsseldienst Notöffnung",
    date: "September 2024",
    rating: 5,
    text: "Mitten in der Nacht ausgesperrt – IGM war in unter 30 Minuten da! Kein Aufpreis für den Nachtdienst, transparente Abrechnung. Genau so stellt man sich einen Notdienst vor.",
  },
  {
    initials: "BL",
    name: "Brigitte L.",
    service: "Umzugsreinigung",
    date: "August 2024",
    rating: 5,
    text: "Die Endreinigung nach unserem Auszug war makellos. Die Wohnung war danach sauberer als beim Einzug. Kaution wurde vollständig zurückerstattet. Vielen Dank an das ganze Team!",
  },
  {
    initials: "NM",
    name: "Nina M.",
    service: "Fensterreinigung",
    date: "Juli 2024",
    rating: 5,
    text: "Streifenfreie Fenster, pünktlicher Termin und ein sehr nettes Team. Der Preis war absolut fair. Ich habe IGM bereits mehreren Freunden empfohlen – alle sind begeistert.",
  },
];

function StarRating({ count }: { count: number }) {
  return (
    <div className="flex gap-0.5">
      {Array.from({ length: 5 }).map((_, i) => (
        <i
          key={i}
          className={`text-sm ${i < count ? "ri-star-fill text-amber-400" : "ri-star-line text-gray-300"}`}
        ></i>
      ))}
    </div>
  );
}

export default function ReviewsSection() {
  const [activeIdx, setActiveIdx] = useState(0);
  const visible = 3;
  const maxIdx = reviews.length - visible;

  const prev = () => setActiveIdx((i) => Math.max(0, i - 1));
  const next = () => setActiveIdx((i) => Math.min(maxIdx, i + 1));

  const visibleReviews = reviews.slice(activeIdx, activeIdx + visible);

  return (
    <section className="py-24 md:py-32 bg-[#F5F5F3]">
      <div className="max-w-7xl mx-auto px-6 md:px-10">

        {/* Header */}
        <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-6 mb-10 md:mb-16">
          <div className="max-w-xl">
            <span className="text-xs font-bold tracking-widest uppercase text-gray-400 mb-4 block">Kundenstimmen</span>
            <h2 className="text-3xl md:text-5xl font-bold text-black leading-tight mb-4" style={{ fontFamily: "'Inter', sans-serif" }}>
              Was unsere Kunden sagen
            </h2>
            <p className="text-gray-500 text-sm md:text-base leading-relaxed">
              Echte Bewertungen von echten Kunden – verifiziert über TrustLocal.
            </p>
          </div>

          {/* Score Badge */}
          <div className="flex items-center gap-4 md:gap-6 bg-white rounded-2xl px-5 md:px-8 py-4 md:py-6 self-start">
            <div className="text-center">
              <p className="text-4xl md:text-5xl font-bold text-black leading-none">9,8</p>
              <div className="flex gap-0.5 justify-center mt-2">
                {Array.from({ length: 5 }).map((_, i) => (
                  <i key={i} className="ri-star-fill text-amber-400 text-sm md:text-base"></i>
                ))}
              </div>
              <p className="text-xs text-gray-400 mt-1.5 font-medium">auf TrustLocal</p>
            </div>
            <div className="w-px h-12 bg-gray-200"></div>
            <div className="flex flex-col gap-2">
              <div className="flex items-center gap-2">
                <div className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-shield-check-line text-green-500 text-sm"></i>
                </div>
                <span className="text-xs font-semibold text-gray-600">Verifizierte Bewertungen</span>
              </div>
              <div className="flex items-center gap-2">
                <div className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-thumb-up-line text-green-500 text-sm"></i>
                </div>
                <span className="text-xs font-semibold text-gray-600">98% Weiterempfehlung</span>
              </div>
              <div className="flex items-center gap-2">
                <div className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-flashlight-line text-amber-500 text-sm"></i>
                </div>
                <span className="text-xs font-semibold text-gray-600">Reagiert schnell</span>
              </div>
            </div>
          </div>
        </div>

        {/* Reviews Grid */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-5 mb-8">
          {visibleReviews.map((r, i) => (
            <div
              key={activeIdx + i}
              className="bg-white rounded-2xl p-7 flex flex-col justify-between transition-all duration-300"
              style={{ animation: "fadeIn 0.35s ease" }}
            >
              <div>
                <div className="flex items-center justify-between mb-4">
                  <StarRating count={r.rating} />
                  <span className="text-xs text-gray-400">{r.date}</span>
                </div>
                <p className="text-gray-700 text-sm leading-relaxed italic mb-6">
                  &ldquo;{r.text}&rdquo;
                </p>
              </div>
              <div className="flex items-center justify-between pt-4 border-t border-gray-100">
                <div className="flex items-center gap-3">
                  <div className="w-10 h-10 flex items-center justify-center rounded-full bg-black text-white text-xs font-bold flex-shrink-0">
                    {r.initials}
                  </div>
                  <div>
                    <p className="text-sm font-semibold text-gray-900">{r.name}</p>
                    <p className="text-xs text-gray-400">{r.service}</p>
                  </div>
                </div>
                <div className="flex items-center gap-1 bg-gray-50 border border-gray-200 rounded-full px-2.5 py-1">
                  <i className="ri-shield-check-line text-green-500 text-xs"></i>
                  <span className="text-xs text-gray-500 font-medium">TrustLocal</span>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Navigation + CTA */}
        <div className="flex flex-col sm:flex-row items-center justify-between gap-5">
          <div className="flex items-center gap-3">
            <button
              onClick={prev}
              disabled={activeIdx === 0}
              className="w-10 h-10 flex items-center justify-center rounded-full border border-gray-300 hover:border-black hover:bg-black hover:text-white transition-all cursor-pointer disabled:opacity-30 disabled:cursor-not-allowed"
            >
              <i className="ri-arrow-left-line text-base"></i>
            </button>
            <div className="flex gap-1.5">
              {Array.from({ length: maxIdx + 1 }).map((_, i) => (
                <button
                  key={i}
                  onClick={() => setActiveIdx(i)}
                  className={`h-1.5 rounded-full transition-all cursor-pointer ${
                    i === activeIdx ? "w-6 bg-black" : "w-1.5 bg-gray-300"
                  }`}
                />
              ))}
            </div>
            <button
              onClick={next}
              disabled={activeIdx === maxIdx}
              className="w-10 h-10 flex items-center justify-center rounded-full border border-gray-300 hover:border-black hover:bg-black hover:text-white transition-all cursor-pointer disabled:opacity-30 disabled:cursor-not-allowed"
            >
              <i className="ri-arrow-right-line text-base"></i>
            </button>
          </div>

          <a
            href="https://trustlocal.de/r/6d29206952"
            target="_blank"
            rel="nofollow noopener noreferrer"
            className="inline-flex items-center gap-2 border border-gray-300 text-gray-700 text-sm font-semibold px-6 py-3 rounded-full hover:border-black hover:text-black transition-all cursor-pointer whitespace-nowrap"
          >
            <i className="ri-external-link-line"></i>
            Alle Bewertungen auf TrustLocal ansehen
          </a>
        </div>

      </div>

      <style>{`
        @keyframes fadeIn {
          from { opacity: 0; transform: translateY(8px); }
          to { opacity: 1; transform: translateY(0); }
        }
      `}</style>
    </section>
  );
}
